import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import isToday from 'date-fns/is_today';
import get from 'lodash/get';
import Cookies from 'js-cookie';

import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import CheckPaymentStatus from 'rebook/apps/payments/components/CheckPaymentStatus';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import Button from 'rebook/apps/base/components/Button';
import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';
import formatCurrency from 'rebook/apps/utils/text/formatCurrency';
import redirectFromIframe from 'rebook/apps/utils/redirectFromIframe';
import AppButton from 'rebook/apps/base/components/AppButton';
import uaDetector from 'rebook/apps/utils/uaDetector';
import CopyToClipboard from 'rebook/apps/base/components/CopyToClipboard';
import PaymentsHeader from 'rebook/apps/payments/components/PaymentsHeader';
import * as UserActions from 'rebook/apps/users/actions/UserActions';
import { SUBSCRIPTION_TYPES } from 'rebook/apps/payments/constants';
import pluralize from 'rebook/apps/utils/text/pluralize';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as PaymentsActions from 'rebook/apps/payments/actions/PaymentsActions';
import { URLS } from 'rebook/apps/base/constants';
import AppsStoreIcons from 'rebook/apps/base/components/AppsStoreIcons';

import styles from './style.scss';


const ReadAppButton = ({ type }) => {
  const UA = navigator && navigator.userAgent ? navigator.userAgent : null;
  const isMobilePlatform = UA && (uaDetector.isAndroid(UA) || uaDetector.isIos(UA));
  const target = (type === 'audio' || type === 'premium')
    ? 'premium_payment_success'
    : 'standart_payment_success';

  return (
    <div className={styles.appButtonContainer}>
      {isMobilePlatform
        ? (
          <AppButton extraClassname={styles.appButton} target={target} />
        )
        : (
          <AppsStoreIcons target={target} />
        )
      }
      <p className={styles.note}>
        Чтобы читать в приложении, войдите под своим логином и паролем.
      </p>
    </div>
  );
};

const PaymentFailed = ({ payment }) => {
  const isFromOffer = get(payment, 'is_intro_offer', false);
  const isFromTrial = get(payment, 'is_trial', false);
  const isFromPayments = !isFromOffer && !isFromTrial;
  let url = '';

  const urls = {
    offer: isFromOffer,
    trialCard: isFromTrial,
    payments: isFromPayments,
  };

  for (let key in urls) {
    if (urls[key]) {
      url = URLS[key];
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.errorIcon} />
      <div className="title-3">Что-то пошло не так</div>
      <p>Советуем вам попробовать оплатить еще раз, или обратиться в службу поддержки -
        <a href={`mailto:${SUPPORT_EMAIL}`}> {SUPPORT_EMAIL}</a>
      </p>
      <div className={styles.appButon}>
        <Button
          handleClick={() => {
            ga('send', 'event', 'MybookEvent Subscription', 'ClickButton', 'Попробовать еще раз');
          }}
          link={url}
          theme="secondary"
          extraClassName="jest-payment-error-try-button">
          <span>Попробовать еще раз</span>
        </Button>
      </div>
    </div>
  );
};

const ChangeUserPasswordLink = ({ isStandard }) => (
  <div className={styles.changePassword}>
    <Link className={styles.changePasswordLink} to={'/account/set-password/'}>
      <div className={styles.changePasswordImage} />
      <span>
        Придумайте себе пароль
      </span>
    </Link>
    <span className={styles.changePasswordTitle}>
      {`А теперь придумайте себе пароль, чтобы читать${isStandard ? ' ' : ' и слушать '}книги в приложении`}
    </span>
  </div>
);

const TrialFailedPayment = () => (
  <div className={classNames('billetContainer', styles.trialFailedContainer)}>
    <div className={classNames('title-1', styles.paymentTitle)}>Ой</div>
    <p>
      У вас уже была подписка, поэтому мы не можем предложить вам 14 дней бесплатно.{' '}
      Но не огорчайтесь, вы всегда можете получить подписку бесплатно, если пригласите к нам друзей.
    </p>
    <Button link={URLS.payments} extraClassName={styles.trialPaymentButton}>
      Оформить подписку
    </Button>
    <div className={styles.trialFailedPicture} />
  </div>
);

const SubscriptionPaidTill = ({ subscriptionTillDate, nextRebillDate, nextRebillAmount, nextRebillCurrency }) => (
  <React.Fragment>
    {nextRebillDate && (
      <p>
        Ваша подписка активна до{' '}
        <FormattedDateTime timestamp={nextRebillDate} format="D MMMM YYYY" noWrap />.
        После окончания подписка будет продлеваться за{' '}
        {formatCurrency(nextRebillAmount, nextRebillCurrency)} ежемесячно.{' '}
        Вы всегда можете отключить автопродление в настройках вашего профиля.
      </p>
    )}
    {subscriptionTillDate && !nextRebillDate && (
      <p>
        Подписка активна до{' '}
        <FormattedDateTime timestamp={subscriptionTillDate} format="D MMMM YYYY" noWrap />
      </p>
    )}
  </React.Fragment>
);

const PaymentPending = () => (
  <div className={styles.spinnerContainer}>
    <SpinnerLoader />
    <div className={classNames('title-3', styles.paymentTitle)}>Пожалуйста, подождите...</div>
  </div>
);

const TrialSuccessPayment = ({ payment, nextRebillAmount, subscriptionType, subscriptionTillDate }) => (
  <div className={classNames(
    'backgroundContainer',
    subscriptionType && subscriptionType.theme,
    payment && !payment.gift && styles.backgroundImage)}>
    <div className={styles.container}>
      {payment && !payment.gift && (
        <div className={styles.container}>
          {subscriptionType.image}
          <div className="title-3">{subscriptionType.name}</div>
          <p className={styles.trialActiveTill}>
            Ваша пробная подписка действует до&nbsp;
            <FormattedDateTime timestamp={payment[subscriptionTillDate]} format="D MMMM YYYY" noWrap />.
          </p>
          <small className={styles.trialSuccessInfo}>
            После окончания пробной подписки со счета спишется
            стоимость следующего месяца&nbsp;—&nbsp;<b>{nextRebillAmount}&nbsp;р/мес.</b>
          </small>
          <small className={styles.trialSuccessInfo}>Вы сможете в любой момент отменить подписку в настройках.</small>
        </div>
      )}
    </div>
  </div>
);

const SuccessPayment = ({
  payment, nextRebillAmount, userEmail,
  subscriptionTypeTitle, subscriptionType, subscriptionTillDate, isNewUser, booksPerSubscriptionCounter,
}) => {
  const SuccessPaymentText = userEmail
    ? (
      <p>
        После покупки подписки вы получите
        код и подарочный сертификат, который придет вам на почту <b>{userEmail}</b>
      </p>
    )
    : (
      <p>
        Подарите купленный код вашему другу или близкому.<br />
        Как подарить?<br />
        Скопировать подарочный код и передать в чат мессенджера или напечатать его на открытке.
      </p>
    );
  return (
    <div className={classNames(
      'backgroundContainer',
      subscriptionType && subscriptionType.theme,
      payment && !payment.gift && styles.backgroundImage)}>
      <div className={styles.container}>
        {payment && !payment.gift && (
          <div className={styles.container}>
            {subscriptionType.image}
            <h1>{subscriptionType.name}</h1>
            <SubscriptionPaidTill
              subscriptionTillDate={payment[subscriptionTillDate]}
              nextRebillDate={payment.wallet && payment.wallet.next_rebill_date}
              nextRebillAmount={nextRebillAmount || payment.amount}
              nextRebillCurrency={payment.currency} />
            {isNewUser
              ? (
                <ChangeUserPasswordLink isStandard={payment.subscription_type === 'standard'} />
              )
              : (
                <ReadAppButton type={payment.subscription_type} />
              )
            }
          </div>
        )}
        {payment && payment.gift && (
          <div className={styles.giftHeader}>
            <PaymentsHeader
              subscriptionType={payment.subscription_type}
              userEmail={userEmail}
              title={subscriptionTypeTitle}
              booksPerSubscriptionCounter={booksPerSubscriptionCounter}
              isGift={!!payment.gift}>
              {SuccessPaymentText}
            </PaymentsHeader>
            <div className={styles.giftContainer}>
              <div className="billetContainer">
                <div className="title-2">Как подарить?</div>
                <p>Можно распечатать и вручить подарок лично или переслать письмо на почту друга</p>
                <p>Еще проще - скопировать подарочный код и передать его в чат мессенджера</p>
                <p>Подарочный код</p>
                <CopyToClipboard
                  extraClassName={styles.giftCode}
                  copiedClassName="isCopied"
                  copiedClassNameDuration={2 * 1000}
                  hasCopyButton>
                  {payment.gift.code}
                </CopyToClipboard>
              </div>
              <div>
                <p>
                  Ваш друг может активировать код
                  на странице ввода подарочного кода или в настройках приложения iOS или Android
                </p>
                <p><b>Спасибо, что выбрали MyBook!</b></p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

class PaymentStatusView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payment: null,
      isError: false,
    };
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      title: `Оплата подписки в в электронной библиотеке MyBook. ` +
        `Читайте более ${this.props.booksPerSubscriptionCounter.total} книг по подписке на iPhone, iPad, Android`,
    });
    Cookies.remove('secondStep');
  }

  componentWillMount() {
    redirectFromIframe();
  }

  componentWillMount() {
    redirectFromIframe();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();

    try {
      window.localStorage.removeItem('bookUrl');
    }
    catch (e) {
      // nothing to do yet
    }
  }

  handleSuccess(payment) {
    const { paymentUuid } = this.props.match.params;
    if (payment && get(payment, 'rent_product')) {
      this.props.history.push({
        pathname: `/payments/rent_status/${paymentUuid}`,
        search: '',
        state: { payment },
      });
    }
    ga('send', 'event', 'Payments', 'ThankYouPage', 'ThankYouPage');

    const eventLabel = {
      pro: 'GotAudio',
      standard: 'GotStandard',
      audio: 'GotAudio',
    };
    if (!payment.gift) {
      ga('send', 'event', {
        eventCategory: 'MybookEvent Subscription',
        eventAction: 'Success',
        eventLabel: eventLabel[payment.subscription_type],
      });
      yaMetrikaReachGoal('Payment');
    }
    else {
      ga('send', 'event', {
        eventCategory: 'MybookEvent Subscription',
        eventAction: 'Success',
        eventLabel: 'GotCodeForGift',
      });
    }

    if (payment.is_intro_offer) {
      yaMetrikaReachGoal('Offer1Month');
    }
    if (get(payment, 'is_trial_payment', false)) {
      ga('send', 'event', {
        eventCategory: 'MybookEvent Subscription',
        eventAction: 'Success',
        eventLabel: 'Audio',
        dimension1: '14trial',
      });
      yaMetrikaReachGoal('GotAudioTrial14', { offer: 'Audio_14trial' });
    }

    this.setState({
      payment,
      isError: false,
    }, () => {
      this.props.UserActions.fetchCurrentUser();
      this.props.PaymentsActions.fetchPrices();
    });
  }

  handleFailure(data) {
    this.setState({
      payment: data,
      isError: true,
    });
  }

  render() {
    const { payment, isError } = this.state;
    const { paymentUuid } = this.props.match.params;
    const { user, payments, booksPerSubscriptionCounter } = this.props;
    const { prices } = payments;
    const subscriptionsTypes = {
      pro: {
        name: 'Премиум-подписка активирована!',
        theme: 'themeYellow',
        image: <SubscriptionIcon type="premium" extraClassName={styles.subscriptionIcon} width="105" height="105" />,
      },
      standard: {
        name: 'Стандартная подписка активирована!',
        theme: 'themeBlue',
        image: <SubscriptionIcon type="standard" extraClassName={styles.subscriptionIcon} width="105" height="105" />,
      },
      audio: {
        name: 'Премиум-подписка активирована!',
        theme: 'themeYellow',
        image: <SubscriptionIcon type="premium" extraClassName={styles.subscriptionIcon} width="105" height="105" />,
      },
    };
    let subscriptionType, nextRebillAmount, monthCount, subscriptionTypeTitle, subscriptionTillDate;
    const userEmail = user && !user.is_fake_email ? user.email : null;

    if (payment) {
      subscriptionType = subscriptionsTypes[payment.subscription_type];
      nextRebillAmount = prices ? prices[payment.subscription_type]['1'].full_price : null;
      monthCount = payment.subscription_months;
      subscriptionTypeTitle = (
        `Поздравляем с покупкой` +
        ` ${monthCount}&nbsp;${pluralize(monthCount, 'месяца', 'месяцев', 'месяцев')}` +
        ` ${SUBSCRIPTION_TYPES[payment.subscription_type.toUpperCase()].GEN}`
      );
      subscriptionTillDate = `${payment.subscription_type}_payed_till`;
    }

    if (payment && payment.is_trial_payment) {
      yaMetrikaReachGoal('Trial');
      ga('send', 'event', 'Trial', 'Subscribe', subscriptionType);
    }

    let bookUrl;

    try {
      bookUrl = window.localStorage.getItem('bookUrl');
    }
    catch (e) {
      // Nothing to do yet
    }

    const isNewUser = isToday(get(user, 'date_joined', null));

    const isSuccessTrialPayment = !isError && payment
      && get(payment, 'is_trial_payment', false)
      && get(payment, 'wallet', false);
    const isErrorTrialPayment = !isError && payment
      && get(payment, 'is_trial_payment', false)
      && !get(payment, 'wallet', false);
    const isSuccessPayment = !isError && payment
      && !get(payment, 'is_trial_payment', false);

    return (
      <React.Fragment>
        <CheckPaymentStatus
          paymentUuid={paymentUuid}
          onSuccess={(payment) => this.handleSuccess(payment)}
          onFail={(data) => this.handleFailure(data)} />
        {!isError && !payment && (
          <PaymentPending />
        )}
        {isErrorTrialPayment && (
          <div className="section backgroundContainer themeGrey">
            <TrialFailedPayment />
          </div>
        )}
        {isSuccessTrialPayment && (
          <TrialSuccessPayment
            payment={payment}
            nextRebillAmount={nextRebillAmount}
            subscriptionTillDate={subscriptionTillDate}
            subscriptionType={subscriptionType}
            url={bookUrl} />
        )}
        {isSuccessPayment && (
          <SuccessPayment
            payment={payment}
            nextRebillAmount={nextRebillAmount}
            subscriptionType={subscriptionType}
            subscriptionTypeTitle={subscriptionTypeTitle}
            userEmail={userEmail}
            isNewUser={isNewUser}
            booksPerSubscriptionCounter={booksPerSubscriptionCounter}
            subscriptionTillDate={subscriptionTillDate} />
        )}
        {isError && (
          <PaymentFailed payment={payment} />
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    payments: state.payments,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    UserActions: bindActionCreators(UserActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
    PaymentsActions: bindActionCreators(PaymentsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentStatusView);
